// extracted by mini-css-extract-plugin
export var scrollArea = "_nf-0";